import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class PwaService {
  constructor() {}

  public initPwaPrompt() {
    // PWA prompt functionality has been removed
  }
}
